module.exports = fox._r("flash/broadcaster_restyle.swf", __webpack_public_path__ + "_/_/_/_/common/liveshow/flash/broadcaster_restyle.swf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/flash/broadcaster_restyle.swf
// module id = 95
// module chunks = 4